/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取用户轨迹列表
export function listUserTrack(params) {
    return request({
        url: 'userTrack/list.do?',
        method: 'post',
        data: params
    })
}

// 新增/编辑用户轨迹
export function saveUserTrack(params) {
    return request({
        url: 'userTrack/save.do?',
        method: 'post',
        data: params
    })
}

// 根据ID删除用户轨迹
export function deleteUserTrackById(params) {
    return request({
        url: 'userTrack/deleteById.do?',
        method: 'post',
        data: params
    })
}

// 导出用户轨迹
export function exportUserTrack(params) {
    return request({
        url: 'userTrack/export.do?',
        method: 'post',
        data: params
    })
}

// 批量导入用户轨迹
export function batchImportUserTrack(params) {
    return request({
        url: 'userTrack/batchImportSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 批量删除用户轨迹
export function batchDeleteUserTrack(params) {
    return request({
        url: 'userTrack/batchDeleteSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
} 